

































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  Configuration,
  RedCapital,
  SelectedCountry,
  TitleTemplatePublic
} from "@/configuration";
import API from "@/api";
import { EventBus } from "@/main";
import CurrencyInput from "@/components/Currency.vue";
import DniPerson from "@/components/DniField.vue";
import DniBusiness from "@/components/DniFieldBusiness.vue";
import { isRutValid } from "@/utils";
import { mapState } from "vuex";
import Axios from "axios";

@Component({

    data() {
      return {
        e1: 3,
        numeroactividad:0,
        siguiente:true,
        dialog:false,
        dialog2:false,
        dialog3:false,
        dialog4:false,
        dialog5:false,
        dialog6:false,
        imageName: '',
		imageUrl: '',
        imageFile: '',
        contador:[],
        siguienteactividad:null,
        actividades:[31,32,33,34],
            respuesta:[],
            realizados1:[],
            r1:[31,32,33,34],
            result1:[],
        FormOne:{
           answers:[

                {
                    user_id: this.$store.state.user.id,
                    cta_answer_id: "311",
                    respuesta:null
                },{
                    user_id: this.$store.state.user.id,
                    cta_answer_id:"312",
                    respuesta:null
                },{
                    user_id: this.$store.state.user.id,
                    cta_answer_id:"313",
                    respuesta:null
                }
            ]
        },
        FormTwo:{
           answers:[
                {
                    user_id: this.$store.state.user.id,
                    cta_answer_id:"321",
                    respuesta:null
                },{
                    user_id: this.$store.state.user.id,
                    cta_answer_id:"322",
                    respuesta:null
                },{
                    user_id: this.$store.state.user.id,
                    cta_answer_id:"323",
                    respuesta:null
                }
            ]
        },
        FormThree:{
            user_id:  this.$store.state.user.id,
            cta_answer_id: "331",
            respuesta: null
        },
        FormFour:{
            answers:[
                {
                    user_id: this.$store.state.user.id,
                    cta_answer_id:"341",
                    respuesta:null
                },{
                    user_id: this.$store.state.user.id,
                    cta_answer_id:"342",
                    respuesta:null
                },{
                    user_id: this.$store.state.user.id,
                    cta_answer_id:"343",
                    respuesta:null
                }
            ]
        },
        rules: {
            notEmpty: [
                (v: any) => !!v || "Ingrese un valor",
                (v: any) => v.length > 3 || "Minimo 4 caracteres"
                ],
            phone: [
            (v: any) => !(/[^\d]/gim.test(v)) || 'Tiene que ser solo numeros',
            (v: any) => !!v || 'Teléfono es requerido',
            ],
            }
        }
    },methods:{
        cerrarmodalabrirmodal(da){
            this.$data.dialog5= false;
            EventBus.$emit("snack-success", "Datos registrados correctamente");
            if(this.$data.contador.length == 4){
                this.$data.dialog2 = true
            }else{
                if(this.$data.contador.indexOf(da) > -1 ){
                    this.$data.siguiente=false;
                    this.$data.dialog = true
                }else{
                    this.$data.siguiente=true;
                    this.$data.dialog = true
                }
            }

        },
        cerrarmodalabrirmodal2(da){
            this.$data.dialog6= false;
            EventBus.$emit("snack-success", "Datos registrados correctamente");
            if(this.$data.contador.length == 4){
                this.$data.dialog2 = true
            }else{
                if(this.$data.contador.indexOf(da) > -1 ){
                    this.$data.siguiente=false;
                    this.$data.dialog = true
                }else{
                    this.$data.siguiente=true;
                    this.$data.dialog = true
                }
            }

        },
        cerrarmodal(modal){
            if(modal == 1){
                this.$data.dialog1 = false
            }else if(modal == 2){
                this.$data.dialog2 = false
            }
            else if(modal == 3){
                this.$data.dialog3 = false
            }
            else if(modal == 4){
                this.$data.dialog4 = false
            }
            else if(modal == 5){
                this.$data.dialog5 = false
            }
            else if(modal == 6){
                this.$data.dialog6 = false
            }
        },
        gosabermas(){
            this.$router.push({
                path: "/actividad/sabermas"
            })
        },
        verbeneficios(numbeneficio){
            this.$data.dialog4 = true 
        },
        vermodalmembresias(numeromodalmembresia){
            this.$data.dialog3 = true
        },
        proximostep(){
            //this.$data.e1 += step;
            const registrar = new Promise((resolve,reject)=>{
                setTimeout(()=>{
                    resolve('datos registrados')
                },1000)
            })
            registrar
            .then((mensaje:any)=> {
                console.log(mensaje)
                 this.$data.dialog = true
                 EventBus.$emit("snack-success", "Datos registrados correctamente");
                })
            .catch(err => console.warn(err))
           

        },
        objetivosmes(){
        
            API.actividad.metascortoplazo.objetivosmes(this.$data.FormOne)
            .then(resolve=>{
                //@ts-ignore
                        this.obtenerdatos()
                        .then((res:any) =>{
                            this.$data.numeroactividad = 1;
                             EventBus.$emit("snack-success", "Datos registrados correctamente");
                            if(res == 9){
                                this.$data.dialog5 =true;
                                this.$data.siguienteactividad= 32;
                            }else if(res == 12){
                                 this.$data.dialog6 =true;
                                 this.$data.siguienteactividad= 32;
                            }else{
                           
                            if(this.$data.contador.length.length == 4){
                                this.$data.dialog2 = true
                            }else{
                                if(this.$data.contador.indexOf(32) > -1 ){
                                    this.$data.siguiente=false;
                                    this.$data.dialog = true
                                }else{
                                    this.$data.siguiente=true;
                                    this.$data.dialog = true
                                }
                            }
                            }
                            
                        })
            })

        },mostrarmodal(){
            
        },
        objetivosanio(){
            API.actividad.metascortoplazo.objetivosmes(this.$data.FormTwo)
            .then(resolve=>{
                //@ts-ignore
                        this.obtenerdatos()
                        .then((res:any) =>{
                            this.$data.numeroactividad = 2;
                             EventBus.$emit("snack-success", "Datos registrados correctamente");
                            if(res == 9){
                                this.$data.dialog5 =true;
                                this.$data.siguienteactividad= 33;
                            }else if(res == 12){
                                 this.$data.dialog6 =true;
                                 this.$data.siguienteactividad= 33;
                            }else{
                                if(this.$data.contador.length == 4){
                                    this.$data.dialog2 = true
                                }else{
                                    if(this.$data.contador.indexOf(33) > -1 ){
                                        this.$data.siguiente=false;
                                        this.$data.dialog = true
                                    }else{
                                        this.$data.siguiente=true;
                                        this.$data.dialog = true
                                    }
                                }
                            }
                            
                        })
            })
        },
        pickFile () {
            //@ts-ignore
            this.$refs.image.click ()
        },
		onFilePicked(e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				this.$data.imageName = files[0].name
				if(this.$data.imageName.lastIndexOf('.') <= 0) {
					return
				}
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
					this.$data.imageUrl = fr.result
                    this.$data.imageFile = files[0] // this is an image file that can be sent to server...
         
				})
			} else {
				this.$data.imageName = ''
				this.$data.imageFile = ''
				this.$data.imageUrl = ''
            }
            this.$data.FormThree.respuesta = files[0]
            //@ts-ignore
            this.guardarimg();
		},
        guardarimg(){
            const data = new FormData();
            data.append('user_id', this.$data.FormThree.user_id);
            data.append('cta_answer_id', this.$data.FormThree.cta_answer_id);
            data.append('respuesta', this.$data.FormThree.respuesta);
            console.log(data)
             Axios.post(`${Configuration.api.base}/cta/cta33`, 
               data
             ,{
            headers: {
                'Content-type':'multiart/form-data',
                Authorization: `Bearer ${this.$store.state.token}`
            }
          }).then(res=>{
             //@ts-ignore
                       this.obtenerdatos()
                        .then((res:any) =>{
                            this.$data.numeroactividad = 3;
                             EventBus.$emit("snack-success", "Datos registrados correctamente");
                            if(res == 9){
                                this.$data.dialog5 =true;
                                this.$data.siguienteactividad= 34;
                            }else if(res == 12){
                                 this.$data.dialog6 =true;
                                 this.$data.siguienteactividad= 34;
                            }else{
                           
                                if(this.$data.contador.length == 4){
                                    this.$data.dialog2 = true
                                }else{
                                    if(this.$data.contador.indexOf(34) > -1 ){
                                        this.$data.siguiente=false;
                                        this.$data.dialog = true
                                    }else{
                                        this.$data.siguiente=true;
                                        this.$data.dialog = true
                                    }
                                }
                            }
                            
                        })
          }).catch(error => console.log(error))
        },
        objetivobussiness(){
            API.actividad.metascortoplazo.objetivosmes(this.$data.FormFour)
            .then(resolve=>{
               //@ts-ignore
                        this.obtenerdatos()
                        .then((res:any) =>{
                            this.$data.numeroactividad = 4;
                            EventBus.$emit("snack-success", "Datos registrados correctamente");
                            if(res == 9){
                                this.$data.dialog5 =true;
                                this.$data.siguienteactividad= 34;
                            }else if(res == 12){
                                 this.$data.dialog6 =true;
                                 this.$data.siguienteactividad= 34;
                            }else{
                           
                                if(this.$data.contador.length == 4){
                                    this.$data.dialog2 = true
                                }else{
                                    if(this.$data.contador.indexOf(34) > -1 ){
                                        this.$data.siguiente=false;
                                        this.$data.dialog = true
                                    }else{
                                        this.$data.siguiente=true;
                                        this.$data.dialog = true
                                    }
                                }
                            }
                        })
            })
        }   
        ,godashboard(){
            this.$router.push({
                path: "/actividad/administracion"
            })
        },
        next(){
            setTimeout(()=>{
                    this.$data.dialog = false
                    this.$data.e1 += 1;
                },1000)
            
        },obtenerdatos(){
           return new Promise((resol,reje)=>{
             //  resol(12)
               //this.$data.contador =[31,32,33]; 
                API.actividad.infoactividades.actividadesrealizadas(this.$store.state.user.id)
                .then((resolve:any)=>{
                    for(let i=0; i < this.$data.actividades.length ;i++){
                        for(let j=0; j < resolve.data.data.length ;j++){
                            if(this.$data.actividades[i]===resolve.data.data[j].cta_list_id){
                                if((this.$data.actividades[i] < 35) && (this.$data.actividades[i] > 25)){
                                    this.$data.realizados1.push(this.$data.actividades[i])
                                }
                            }
                        }
                    }
                    resol(resolve.data.data.length)
                    this.$data.contador = Array.from(new Set(this.$data.realizados1));
                }).catch(error => console.log(error))
           })
        }
    },async beforeMount(){
        let etapa = this.$route.params.etapa;
        if (this.$route.params.etapa != null){
            this.$data.e1 = this.$route.params.etapa
        }
        API.actividad.infoactividades.actividadesrealizadas(this.$store.state.user.id)
                .then((resolve:any)=>{
                    for(let i=0; i < this.$data.actividades.length ;i++){
                        for(let j=0; j < resolve.data.data.length ;j++){
                            if(this.$data.actividades[i]===resolve.data.data[j].cta_list_id){
                                if((this.$data.actividades[i] < 35) && (this.$data.actividades[i] > 25)){
                                    this.$data.realizados1.push(this.$data.actividades[i])
                                }
                            }
                        }
                    }
                    this.$data.realizados1 = Array.from(new Set(this.$data.realizados1))
                }).catch(error => console.log(error))
        }
  
})
export default class OrganizaTusFinanzas extends Vue {}
